import { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export type GetInstructorParams = {
  id: string;
};

export type InstructorUser = {
  tenant_id: string;
  id: string;
  title: string | null;
  first_name: string | null;
  middle_name: string | null;
  last_name: string | null;
  nickname: string | null;
  email: string | null;
  date_of_birth: string | null;
  sex: string | null;
  active: boolean;
  created_at: string | null;
  updated_at: string | null;
  created_by: string | null;
  updated_by: string | null;
  des_id: string | null;
  instructor: {
    tenant_id: string;
    user_id: string;
    calendar_color: string | null;
    created_at: string | null;
    updated_at: string | null;
  };
};

async function getInstructor(params: GetInstructorParams) {
  // make api call
  const result = await privateApi.get<InstructorUser>(
    `${import.meta.env.VITE_API_BASE_URL}/users/instructors/${params.id}`,
    {},
  );

  return result.data;
}

const useGetInstructor = createQuery<InstructorUser, GetInstructorParams, AxiosError<ErrorResponse>>({
  queryKey: ['instructor'],
  fetcher: (variables) => getInstructor(variables),
});

export { getInstructor, useGetInstructor };
